{
  "appName": "Nexa",
  "companyLegalName": "NewEra Inc.",
  "companyAddress": "Lim Tower 3, 29A Nguyễn Đình Chiểu, Phường Đa Kao, Quận 1, TP. Hồ Chí Minh",
  "supportEmail": "support@newera.inc",
  "privacyEmail": "support@newera.inc",
  "deletionEmail": "support@newera.inc",
  "supportHours": "24/7",
  "aiProvider": "Anthropic",
  "analyticsProvider.vi": "Không sử dụng",
  "analyticsProvider.en": "Not used",
  "retentionPeriod.vi": "30 ngày",
  "retentionPeriod.en": "30 days",
  "effectiveDate": "01/07/2026",
  "lastUpdated": "11/06/2026"
}
